import defaultTransition from './default';

export default [defaultTransition];
